import { DEFAULT_TOOLTIP_POSITION } from './constants'
import { TooltipCoordinates, TooltipPosition, TooltipSize } from './types'

const getIsTooltipFitsInPositionMap: Record<
  TooltipPosition,
  (tooltipPoint: TooltipCoordinates, tooltipSize: TooltipSize, viewportSize: TooltipSize) => boolean
> = {
  top: (tooltipPoint, tooltipSize) => {
    return tooltipPoint.y - tooltipSize.height >= 0
  },
  bottom: (tooltipPoint, tooltipSize, viewportSize) => {
    return tooltipPoint.y + tooltipSize.height <= viewportSize.height
  },
  left: (tooltipPoint, tooltipSize) => {
    return tooltipPoint.x - tooltipSize.width >= 0
  },
  right: (tooltipPoint, tooltipSize, viewportSize) => {
    return tooltipPoint.x + tooltipSize.width <= viewportSize.width
  },
  right_bottom: (tooltipPoint, tooltipSize, viewportSize) => {
    return tooltipPoint.x + tooltipSize.width <= viewportSize.width
  },
  left_bottom: (tooltipPoint, tooltipSize) => {
    return tooltipPoint.x - tooltipSize.width >= 0
  },
}

export const getIsTooltipFitsInPosition = ({
  position,
  tooltipPoint,
  tooltipSize,
  viewportSize,
}: {
  position: TooltipPosition
  tooltipPoint: TooltipCoordinates
  tooltipSize: TooltipSize
  viewportSize: TooltipSize
}) => {
  const isTooltipFits =
    getIsTooltipFitsInPositionMap[position] ||
    getIsTooltipFitsInPositionMap[DEFAULT_TOOLTIP_POSITION]

  return isTooltipFits(tooltipPoint, tooltipSize, viewportSize)
}
